export default "__VITE_ASSET__QkHzkM9z__"